var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"page",attrs:{"page-size":_vm.pageSize,"page-size-opts":_vm.opts,"total":_vm.pageTotal,"size":"small","show-elevator":"","show-sizer":"","current":_vm.chectedPage},on:{"on-page-size-change":_vm.totalPageChange,"on-change":_vm.pageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }